__webpack_require__.p = "/GOL/";